import { c as _c } from "react/compiler-runtime";
import { Divider } from '@sola/ark-core/atoms/divider/divider.tsx';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CommitmentCardPayment } from '../commitment-card-payment/commitment-card-payment.tsx';
export interface MakeAPaymentSectionProps {
  title: string;
  description: string;
  commitments: GraphQLCommitment[];
  alertMessage?: string;
}
export const MakeAPaymentSection: React.FC<MakeAPaymentSectionProps> = t0 => {
  const $ = _c(16);
  const {
    title,
    description,
    commitments,
    alertMessage
  } = t0;
  if (commitments.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== alertMessage) {
    t1 = alertMessage && <Alert message={<IntlBlock i18nKey={alertMessage} />} />;
    $[0] = alertMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <span className="heading-xs">{title}</span>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = <span className="body-sm body-neutral-mild">{description}</span>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-snug-lg">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== commitments) {
    t5 = commitments.map(_temp);
    $[9] = commitments;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider purpose="neutral" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t5) {
    t7 = <>{t1}{t4}{t5}{t6}</>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
function _temp(commitment) {
  return <CommitmentCardPayment key={commitment.internalId} commitment={commitment} />;
}